// Admin Authentication Context
import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminApi } from '../utils/api';

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const session = await adminApi.checkSession();
      setAdmin(session);
    } catch (error) {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const result = await adminApi.login(email, password);
    // Re-check auth status after login
    await checkAuth();
    return result;
  };

  const setup = async (email, password, confirmPassword) => {
    const result = await adminApi.setup(email, password, confirmPassword);
    // Re-check auth status after setup
    await checkAuth();
    return result;
  };

  const logout = async () => {
    await adminApi.logout();
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, checkAuth, setup }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
};
